import Logo from 'Components/Icons/Logo'
import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

function SigninHeader() {

  return (
    <div className='w-full flex justify-center lg:justify-between  items-center p-4 border-b border-1 bg-white'>
        <div className='w-[400px] flex justify-center lg:justify-start'>
           <Link to='/'>
            <div className='flex'>
               <Logo/>&nbsp;   
            </div>
            </Link>
        </div>
          <div className=''>
         
        </div>
    </div>
  )
}

export default SigninHeader